import { ApartmentOutlined, InfoCircleOutlined } from '@ant-design/icons'
import { t } from 'i18next'
import ResponsiveTabs, {
  TabItem,
} from '../../../components/display/ResponsiveTab'
import { WorkspaceTab, workspaceTabs } from '../WorkspaceDetailsPage'

interface DocumentSetDetailsPageTabsProps {
  selectedWorkspaceTab: WorkspaceTab
  handleChange: (workspaceTab: string) => void
}

const DocumentSetDetailsPageTabs = ({
  selectedWorkspaceTab,
  handleChange,
}: DocumentSetDetailsPageTabsProps) => {
  const tabs: TabItem[] = [
    {
      key: workspaceTabs.INFO,
      icon: <InfoCircleOutlined />,
      label: t('workspaceDetailsPage.workspaceTabs.tabInfo'),
    },
    {
      key: workspaceTabs.SMART_FUNCTION,
      icon: <ApartmentOutlined />,
      label: t('workspaceDetailsPage.workspaceTabs.tabIntelligentSolution'),
    },
  ]

  return (
    <ResponsiveTabs
      tabs={tabs}
      selectedTab={selectedWorkspaceTab}
      onTabChange={handleChange}
    />
  )
}

export default DocumentSetDetailsPageTabs
